export default "__VITE_ASSET__Q5hkHsUr__"